<div class="buttons-section">
    <div *ngFor="let button of buttons">
        <button class="option-button" (click)="Abrir(button.target)" *ngIf="button.show">
            <mat-icon>{{button.icon}}</mat-icon>
            {{button.title}}
        </button>
    </div>
</div>